import {
  approvalItemsProcess
} from '@/api/approval'

const approval = {
  state: {

  },
  mutations: {

  },
  actions: {
    ApprovalItemsProcess ({ commit }) {
      return new Promise((resolve, reject) => {
        approvalItemsProcess().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default approval



// WEBPACK FOOTER //
// ./src/store/modules/approval.js